module.exports = __webpack_public_path__ + "static/media/linkedin-footer.bcbb4aa5.svg";